import apiFetch from '../apiFetch'

export default function (listTipoDiluyente, token) {
  return apiFetch({endPoint: `TipoDiluyente/deleteSeleccionTipoDiluyente`, method: 'POST', body: listTipoDiluyente, token: token})
}
